/* eslint-disable import/prefer-default-export */
export const ABOUT_US_LINK = 'https://relevo.app/kontakt/';
